export const selectSearchContacts = state => state.searchContacts
